import { z } from "zod";

export enum ESubscriberFeedbackFormType {
  ABUSE_REPORT = "ABUSE_REPORT",
  INSTALL_SATISFACTION = "INSTALL_SATISFACTION",
}

export const subscriberFeedbackAllowedFormDtoSchema = z.object({
  type: z.nativeEnum(ESubscriberFeedbackFormType),
  enabled: z.boolean(),
});

export type TSubscriberFeedbackAllowedFormDto = z.infer<typeof subscriberFeedbackAllowedFormDtoSchema>;
